var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBevoLenkgetriebe48(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.1,26.1h0.3c0.9,0,2.7-1.1,2.7-2.8c0-1.7-2.8-8.3-2.8-8.3h0c0,0-2.8,6.6-2.8,8.3C21.4,25,23.2,26.1,24.1,26.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8,21.6l-3.2-0.2c-0.4,0-0.8,0.3-0.8,0.7L34.5,26h-7.2c-0.8,1-2.1,1.7-3,1.7h-0.4c-0.8,0-2.2-0.7-3-1.7h-7.5l0.2-3.6 c0-0.4-0.3-0.8-0.7-0.8l-3.2-0.2c-0.4,0-0.8,0.3-0.8,0.7L8.5,32c0,0.4,0.3,0.8,0.7,0.8l3.2,0.2c0.4,0,0.8-0.3,0.8-0.7l0.3-4h20.9 L34.2,32c0,0.4,0.3,0.8,0.7,0.8l3.2,0.2c0.4,0,0.8-0.3,0.8-0.7l0.6-9.9C39.5,22,39.2,21.6,38.8,21.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBevoLenkgetriebe48);
export default __webpack_public_path__ + "static/media/ic_bevo_lenkgetriebe_48.bde9914cfd30ed6fb8b7f9395f47d696.svg";
export { ForwardRef as ReactComponent };